<template>
  <div>
    <item-modal :statement="selectedStatement" :item="editItem" :item-index="itemIndex"></item-modal>
    <div class="row">
      <div class="col-lg-12">
        <div class="col-lg-3">
          <v-select placeholder="Client" :options="f.clients" label="name" index="id" v-model="client" @input="fetchStatements"></v-select>
        </div>
        <button class="btn btn-xs btn-primary pull-right" v-if="client" data-toggle="modal" data-target="#create-statement"><i class="fa fa-plus"></i> New Statement</button>
        <statement-modal :client="client"></statement-modal>
      </div>
    </div>
    <div class="m-t-sm ibox-content">
      <div class="col-lg-3">
        <table class="table-bordered table-hover table">
          <tbody>
          <tr v-for="statement in statements" :key="statement.id">
            <td class="pointer" @click="loadStatement(statement.id)">
              <i class="fa fa-check green pull-right" v-tooltip="'Issued'" v-if="statement.status === 'issued'"></i>
              <i class="fa fa-clock orange pull-right" v-tooltip="'Open'" v-if="statement.status === 'open'"></i>
              <h4>{{ statement.name }}</h4>
              {{ statement.sum }} €
              ({{ statement.startDate | aTime('DD.MM.') }} - {{ statement.endDate | aTime('DD.MM.') }})
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="col-lg-9" v-if="selectedStatement && selectedStatement.name">
        <div class="row">
          <div class="col-lg-12 text-right">
            <h4 class="text-navy">{{ selectedStatement.name }}</h4>
            <p>To: <strong>{{ selectedStatement.client.name }}</strong></p>
            <p>
              <span v-if="selectedStatement.status === 'open'">
                <strong>Last change:</strong> {{ selectedStatement.lastAction | aTime('DD.MM.Y HH:mm') }}
              </span>
              <span v-if="selectedStatement.status === 'issued'">
                <strong>Issued:</strong> {{ selectedStatement.lastAction | aTime('DD.MM.Y HH:mm') }}
              </span>
              <br>
              <strong>Period:</strong> {{ selectedStatement.startDate | aTime('DD.MM.Y') }} - {{ selectedStatement.endDate | aTime('DD.MM.Y') }}
            </p>
          </div>
        </div>
        <div class="row">
        <table class="table invoice-table">
          <thead>
          <tr>
            <th>Item</th>
            <th>Quantity</th>
            <th>Price</th>
            <th>Total</th>
            <th v-if="selectedStatement.status === 'open'"><a data-toggle="modal" data-target="#edit-item" @click="editItem = {}"><i class="fa fa-plus green" v-tooltip="'Add Item'"></i></a></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, i) in selectedStatement.items" :key="'item-' + i">
            <td class="col-lg-8">
              <div><strong>{{ item.name }}</strong></div>
              <small>{{ shorten(item.description, 200) }}</small>
            </td>
            <td class="center bold">{{ item.quantity }}</td>
            <td class="center bold">€{{ item.price }}</td>
            <td class="center bold">€{{ item.sum }}</td>
            <td v-if="selectedStatement.status === 'open'">
              <a v-tooltip="'Edit'" data-toggle="modal" data-target="#edit-item" @click="editItem = {index: i, ...item}"><i class="fas fa-pen"></i></a>
              <a v-tooltip="'Remove'" @click="removeItem(i)"><i class="fas fa-trash red"></i></a>
            </td>
          </tr>
          <tr>
            <td colspan="3" style="text-align: right;" class="bold">Total:</td>
            <td class="bold">€{{ selectedStatement.sum }}</td>
            <td></td>
          </tr>
          <tr>
            <td colspan="5">
              <button class="btn btn-sm btn-primary" v-if="selectedStatement.status === 'open'" @click="issueStatement">Issue Statement</button>
              <button class="btn btn-sm btn-danger" v-if="selectedStatement.status === 'open'" @click="deleteStatement">Delete Statement</button>
            </td>
          </tr>
          </tbody>
        </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import ItemModal from './Statements/ItemModal'
import StatementModal from './Statements/StatementModal'
import { eventBus } from '../../../../../main'
import { String } from '../../../../../mixins/helperMixin'

export default {
  data () {
    return {
      client: null,
      statements: [],
      selectedStatement: null,
      editItem: {},
      itemIndex: null
    }
  },
  mixins: [String],
  components: {
    ItemModal,
    StatementModal
  },
  computed: {
    ...mapGetters({
      f: 'getFilters'
    })
  },
  mounted () {
    if (!this.f.clients) {
      this.$store.dispatch('loadFilters')
    }
    eventBus.$on('reloadStatements', () => {
      this.fetchStatements()
    })
    eventBus.$on('loadStatement', (id) => {
      this.loadStatement(id)
    })
  },
  methods: {
    fetchStatements (resetSelected = true) {
      axios.get('/billing/statements?client=' + this.client)
        .then(r => {
          this.statements = r.data.data.sort((a, b) => a.startDate.date - b.startDate.date)
          if (resetSelected) {
            this.selectedStatement = {}
          }
        })
    },
    loadStatement (id) {
      axios.get(`/billing/statement/${id}`)
        .then(r => {
          this.selectedStatement = r.data
        })
    },
    removeItem (i) {
      if (!confirm('Delete item?')) {
        return
      }
      axios.delete(`/billing/statement/${this.selectedStatement.id}/item/${i}`)
        .then(r => {
          this.loadStatement(this.selectedStatement.id)
          this.fetchStatements(false)
        })
    },
    issueStatement () {
      if (!confirm('Do you want to issue the statement?')) {
        return
      }
      axios.patch(`/billing/statement/${this.selectedStatement.id}`, {
        status: 'issued'
      })
        .then(r => {
          this.fetchStatements(false)
          this.selectedStatement = r.data.statement
        })
    },
    deleteStatement () {
      if (!confirm('Do you want to delete the statement?')) {
        return
      }
      axios.delete(`/billing/statement/${this.selectedStatement.id}`)
        .then(r => {
          this.fetchStatements()
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Admin/Billing/Tabs/Statements.vue